import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { uploadImage } from '../../Services/azure-storage-blob';
import { toast } from 'react-toastify';
// import axios from 'axios';
import cookieUtils from '../../utils/cookieUtils';
import CustomDropdown from './CustomDropdown';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import Search from '../../../src/assets/images/svg/search.svg';
import { _axios } from '../../utils/axios';

const processHtmlForPreview = (html) => {
    if (!html) return '<p>Your content will appear here...</p>';

    // Create a temporary div to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Style all ol elements
    const olElements = tempDiv.querySelectorAll('ol');
    olElements.forEach(ol => {
        ol.style.paddingLeft = '20px';
        ol.style.margin = '10px 0';
        ol.style.listStyleType = 'decimal';
        ol.style.listStylePosition = 'outside';
        ol.style.display = 'block';
    });

    // Style all ul elements
    const ulElements = tempDiv.querySelectorAll('ul');
    ulElements.forEach(ul => {
        ul.style.paddingLeft = '20px';
        ul.style.margin = '10px 0';
        ul.style.listStyleType = 'disc';
        ul.style.listStylePosition = 'outside';
        ul.style.display = 'block';
    });

    // Style all li elements
    const liElements = tempDiv.querySelectorAll('li');
    liElements.forEach(li => {
        li.style.display = 'list-item';
        li.style.margin = '5px 0';
        li.style.lineHeight = '1.6';
        li.style.listStylePosition = 'outside';
    });

    return tempDiv.innerHTML;
};

const CreateCourse = ({ show, onHide }) => {

    const containsInvalidCharacters = (text) => {
        // This regex pattern will detect emojis and many special unicode characters
        const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;

        // Test if the text contains emojis or other invalid characters
        return emojiRegex.test(text);
    };
    // Get user ID from cookies
    const userRole = cookieUtils.getSecureCookie('role');
    const adminId = cookieUtils.getSecureCookie('admin_id');
    const userId = cookieUtils.getSecureCookie('user_id');
    const [fieldErrors, setFieldErrors] = useState({
        title: '',
        description: ''
    });

    // Use appropriate ID based on user role
    const currentId = userRole === 'superadmin' ? adminId : userId;

    // Initial form state
    const initialFormState = {
        title: '',
        description: '',
        courseType: '',
        status: '',
        category: '',
        language: '',
        subscriptionType: 'Free',
        certificateEnabled: false,
        introduction_video_url: ''
    };

    // Initial thumbnail state
    const initialThumbnailState = {
        file: null,
        preview: null
    };
    const initialVideoState = {
        file: null,
        preview: null
    }

    const [formData, setFormData] = useState(initialFormState);
    const [thumbnail, setThumbnail] = useState(initialThumbnailState);
    const [introVideo, setIntroVideo] = useState(initialVideoState);
    const [charCount, setCharCount] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [introMediaType, setIntroMediaType] = useState('video');
    const [htmlContent, setHtmlContent] = useState('');
    const [showPreview, setShowPreview] = useState(false);
    const [journeyResults, setJourneyResults] = useState([]);
    const [selectedJourneys, setSelectedJourneys] = useState([]);
    const [searchJourney, setSearchJourney] = useState('');
    // For Deities
    const [deityResults, setDeityResults] = useState([]);
    const [selectedDeities, setSelectedDeities] = useState([]);
    const [searchDeity, setSearchDeity] = useState('');

    // For Teerthas (Waypoints)
    const [waypointResults, setWaypointResults] = useState([]);
    const [selectedWaypoints, setSelectedWaypoints] = useState([]);
    const [searchWaypoint, setSearchWaypoint] = useState('');

    const getJourneys = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/tripdetails`);
            console.log('Journeys', response);
            const actualData = response?.data.data;
            setJourneyResults(actualData);
        } catch (error) {
            console.error("Error fetching journeys:", error);
            toast.error("Failed to load parikramas");
        }
    };

    useEffect(() => {
        getJourneys();
        getDeities();
    }, []);

    const handleJourneySelect = (journey) => {
        const isAlreadySelected = selectedJourneys.some(j => j.journey_id === journey.journey_id);
        if (isAlreadySelected) {
            return;
        } else {
            const updatedJourneys = [...selectedJourneys, journey];
            setSelectedJourneys(updatedJourneys);
            setSearchJourney('');
        }
    };

    const handleJourneyRemove = (journeyId) => {
        const updatedJourneys = selectedJourneys.filter(j => j.journey_id !== journeyId);
        setSelectedJourneys(updatedJourneys);
    };

    // For Deities
    const getDeities = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/deity`);
            console.log('Deity result', response);
            const actualData = response?.data.data;
            setDeityResults(actualData);
        } catch (error) {
            console.error("Error fetching deities:", error);
            toast.error("Failed to load deities");
        }
    };

    const handleDeitySelect = (deity) => {
        const isAlreadySelected = selectedDeities.some(d => d.deity_id === deity.deity_id);
        if (!isAlreadySelected) {
            const updatedDeities = [...selectedDeities, deity];
            setSelectedDeities(updatedDeities);
            setSearchDeity('');
        }
    };

    const handleDeityRemove = (deityId) => {
        const updatedDeities = selectedDeities.filter(d => d.deity_id !== deityId);
        setSelectedDeities(updatedDeities);
    };

    // For Teerthas (Waypoints)
    const searchWaypoints = async (term) => {
        if (term.length < 2) {
            setWaypointResults([]);
            return;
        }

        try {
            // Use getAllWaypoints which returns all waypoints
            const response = await _axios.post(`${ServerPath}/gpx_route/getAllWaypoints`, {
                // You can leave location and radius parameters empty to get all waypoints
                location: null,
                radius: null
            });

            if (response.data.success) {
                // Filter waypoints by the search term client-side
                const searchLower = term.toLowerCase();
                const filteredWaypoints = response.data.data.filter(waypoint =>
                    waypoint.wpt_name.toLowerCase().includes(searchLower) ||
                    (waypoint.place && waypoint.place.toLowerCase().includes(searchLower))
                );

                setWaypointResults(filteredWaypoints);
            }
        } catch (error) {
            console.error("Error searching waypoints:", error);
            toast.error("Failed to search waypoints");
        }
    };

    const handleWaypointSelect = (waypoint) => {
        const isAlreadySelected = selectedWaypoints.some(w => w.wpt_id === waypoint.wpt_id);
        if (!isAlreadySelected) {
            const updatedWaypoints = [...selectedWaypoints, {
                wpt_id: waypoint.wpt_id,
                wpt_name: waypoint.wpt_name
            }];
            setSelectedWaypoints(updatedWaypoints);
            setSearchWaypoint('');
        }
    };

    const handleWaypointRemove = (waypointId) => {
        const updatedWaypoints = selectedWaypoints.filter(w => w.wpt_id !== waypointId);
        setSelectedWaypoints(updatedWaypoints);
    };

    const sunEditorOptions = {
        buttonList: [
            ['undo', 'redo'],
            ['font', 'fontSize', 'formatBlock'],
            ['bold', 'italic', 'underline', 'strike'],
            ['fontColor', 'hiliteColor'],
            ['align', 'list', 'lineHeight'],
            ['outdent', 'indent'],
            ['link'],
            ['fullScreen'],
            // ['preview']
        ],
        height: 200,
        placeholder: 'Enter your literature content here...',
        resizingBar: false,
        showPathLabel: false,
        charCounter: false,
        maxCharCount: null
    };

    // Quill editor configuration
    // const quillModules = {
    //     toolbar: [
    //         [{ 'header': [1, 2, 3, false] }],
    //         ['bold', 'italic', 'underline', 'strike'],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         [{ 'indent': '-1' }, { 'indent': '+1' }],
    //         ['link', 'image'],
    //         [{ 'align': [] }],
    //         [{ 'color': ['#000000'] }], // Only black color
    //         ['clean']
    //     ],
    // };

    // const quillFormats = [
    //     'header', 'bold', 'italic', 'underline', 'strike',
    //     'list', 'bullet', 'indent', 'link', 'image',
    //     'align', 'color', 'background'
    // ];

    const containsAlphanumeric = (text) => {
        const alphanumericRegex = /[a-zA-Z0-9]/; // Matches any letter or number
        return alphanumericRegex.test(text);
    };
    // Handle input changes
    // In CreateCourse.jsx and EditCourse.jsx, modify the handleInputChange function:
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Validate for emojis and special characters
        if (containsInvalidCharacters(value)) {
            toast.error("Please enter valid text. Emojis and unsupported symbols are not allowed.", {
                toastId: 'emoji-error'
            });
            return;
        }

        // NEW VALIDATION: Check if title or description contains at least one alphanumeric character
        if ((name === 'title' || name === 'description') && value.trim() !== '' && !containsAlphanumeric(value)) {
            toast.error("Please enter a valid Course Name and Description using letters or numbers.", {
                toastId: 'alphanumeric-error'
            });
            return;
        }

        // Existing code for description length validation
        if (name === 'description') {
            if (value.length > 300) {
                toast.error('Description can not exceed 300 characters', {
                    toastId: 'length-error'
                });
                return;
            }
            setCharCount(value.length);
        }
        if (name === 'courseType') {
            // Set appropriate media type based on course type
            switch (value) {
                case 'Text-Based Course':
                    setIntroMediaType('text');
                    break;
                case 'Audio':
                    setIntroMediaType('audio');
                    break;
                default: // 'Video Course'
                    setIntroMediaType('video');
            }

            // Clear existing intro content when changing course type
            if (value !== 'Text-Based Course') {
                setHtmlContent('');
            }
            if (introVideo.file || introVideo.preview) {
                if (introVideo.preview && !introVideo.preview.includes('http')) {
                    URL.revokeObjectURL(introVideo.preview);
                }
                setIntroVideo(initialVideoState);
            }
        }

        // All validations passed, update form data
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle checkbox changes
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    // Handle thumbnail upload
    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file type
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
            toast.error('Please upload an image file (PNG or JPEG)');
            return;
        }

        // Validate file size (max 3MB)
        const maxSize = 3 * 1024 * 1024;
        if (file.size > maxSize) {
            toast.error('Image size should be less than 3 MB');
            return;
        }

        // Create preview URL
        const previewUrl = URL.createObjectURL(file);

        setThumbnail({
            file,
            preview: previewUrl
        });
    };

    // Inside handleVideoChange function
    const handleIntroMediaChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check if course type is selected
        if (!formData.courseType) {
            toast.error('Please select a Course Type before uploading introduction media', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                toastId: 'select-course-type-error'
            });
            return;
        }

        // Validate file type based on course type
        let allowedTypes = [];
        let maxSize = 0;
        let errorMessage = '';

        switch (formData.courseType) {
            case 'Text-Based Course':
                // This shouldn't happen as Text-Based Course uses Quill editor
                toast.error('Text-Based Course uses text editor, not file upload');
                return;
            case 'Audio':
                allowedTypes = ['audio/mpeg', 'audio/mp3', 'audio/wav'];
                maxSize = 15 * 1024 * 1024; // 15MB
                errorMessage = 'Please upload an audio file (MP3/WAV) less than 15 MB';
                break;
            default: // Video Course
                allowedTypes = ['video/mp4'];
                maxSize = 20 * 1024 * 1024; // 20MB
                errorMessage = 'Please upload an MP4 video file less than 20 MB';
        }

        if (!allowedTypes.includes(file.type)) {
            toast.error(`Invalid file type. ${errorMessage}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                toastId: 'file-type-error'
            });
            return;
        }

        if (file.size > maxSize) {
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                toastId: 'file-size-error'
            });
            return;
        }

        // Set the file and preview
        setIntroVideo({
            file,
            preview: formData.courseType === 'Video Course' ? URL.createObjectURL(file) : null
        });
    }

    // Trigger file input click
    const triggerFileInput = () => {
        document.getElementById('thumbnailFile').click();
    };

    // Convert image file to base64
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // Extract the base64 string without the data URL prefix
                const base64String = reader.result.split(',')[1];
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };

    // Form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting || isSubmitted) return;

        try {
            setIsSubmitting(true);

            // Validate required fields
            if (!formData.title.trim() || !formData.description.trim() || !formData.courseType ||
                !formData.status || !formData.category) {
                toast.error('Please fill in all required fields with valid text');
                setIsSubmitting(false);
                return;
            }

            // Title validation
            if (formData.title.length < 2 || formData.title.length > 50) {
                toast.error('Title must be between 2 and 50 characters');
                setIsSubmitting(false);
                return;
            }

            // Description validation
            if (formData.description.length > 300) {
                toast.error('Description must be a maximum of 300 characters');
                setIsSubmitting(false);
                return;
            }
            const journeys = selectedJourneys.map((journey) => journey?.journey_id);
            const deities = selectedDeities.map((deity) => deity?.deity_id);
            const waypoints = selectedWaypoints.map((waypoint) => waypoint?.wpt_id);
            // Create course data object
            const courseData = {
                user_id: currentId,
                title: formData.title,
                short_description: formData.description,
                course_type: formData.courseType,
                category: formData.category,
                language: formData.language,
                subscription_type: formData.subscriptionType,
                certificate_enabled: formData.certificateEnabled ? 1 : 0,
                status: formData.status,
                journey_id: journeys.join(','),
                deity_id: deities.join(','),
                waypoint_id: waypoints.join(','),
                waypoint_name: selectedWaypoints.map(w => w.wpt_name).join(',')
            };

            // Handle introduction content based on course type
            if (formData.courseType === 'Text-Based Course') {
                // For text-based courses, store HTML content directly
                courseData.introduction_video_url = htmlContent;
            } else if (introVideo.file) {
                // For other course types, handle file upload
                const mediaBase64Data = await fileToBase64(introVideo.file);
                courseData.introduction_video_base64 = mediaBase64Data;
                courseData.introduction_video_type = introVideo.file.type;
                courseData.introduction_video_name = introVideo.file.name;
            }

            // Add thumbnail if available
            if (thumbnail.file) {
                const base64Data = await fileToBase64(thumbnail.file);
                courseData.thumbnail_base64 = base64Data;
                courseData.thumbnail_type = thumbnail.file.type;
                courseData.thumbnail_name = thumbnail.file.name;
            }

            // Make API call
            const response = await _axios.post(`${ServerPath}/course/create`, courseData);

            if (response.data.success) {
                setIsSubmitted(true);
                toast.success('Course has been successfully created');
                resetForm();
                onHide();

                // Optional: reload data
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        } catch (error) {
            console.error('Error creating course:', error);
            toast.error(error.response?.data?.message || 'Failed to create course');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Reset form
    const resetForm = () => {
        setFormData(initialFormState);
        setThumbnail(initialThumbnailState);
        setCharCount(0);
        setHtmlContent('');
        setShowPreview(false);

        // Revoke any object URLs to prevent memory leaks
        if (thumbnail.preview) {
            URL.revokeObjectURL(thumbnail.preview);
        }
        if (introVideo.preview) {
            URL.revokeObjectURL(introVideo.preview);
        }
        setIntroVideo(initialVideoState);
    };

    // Handle modal close
    const handleClose = () => {
        resetForm();
        onHide();
    };

    // Render thumbnail preview
    const renderThumbnailPreview = () => {
        if (thumbnail.preview) {
            return (
                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                    <img
                        src={thumbnail.preview}
                        alt="Thumbnail Preview"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                        }}
                    />
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            setThumbnail(initialThumbnailState);
                        }}
                        className="position-absolute"
                        style={{
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '4px 8px',
                            fontSize: '12px',
                            cursor: 'pointer'
                        }}
                    >
                        Remove
                    </button>
                </div>
            );
        }

        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
                <span style={{ fontSize: '32px', color: '#A0AEC0' }}>+</span>
                <p style={{
                    fontSize: '10px',
                    color: '#718096',
                    margin: '0',
                    whiteSpace: 'pre-line',
                    maxWidth: '200px'
                }}>
                    Please upload thumbnail in PNG or JPG format
                </p>
            </div>
        );
    };

    // Render introduction media section
    const renderIntroductionMediaSection = () => {
        if (formData.courseType === 'Text-Based Course') {
            // Return empty div for text-based courses since Quill editor will be below
            return null;
        }

        return (
            <div className="col-md-6 ps-md-2">
                <Form.Group>
                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                        {formData.courseType === 'Audio' ? 'Introduction Audio' : 'Introduction Video'}
                    </Form.Label>
                    <input
                        type="file"
                        id="introMediaFile"
                        onChange={handleIntroMediaChange}
                        style={{ display: 'none' }}
                        accept={formData.courseType === 'Audio' ? 'audio/mpeg,audio/mp3,audio/wav' : 'video/mp4'}
                    />
                    <div
                        className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                        style={{
                            height: '150px',
                            backgroundColor: '#FFFFFF',
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            if (!formData.courseType) {
                                toast.error('Please select a Course Type first before uploading introduction media', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    toastId: 'select-course-type-first'
                                });
                                return;
                            }
                            document.getElementById('introMediaFile').click();
                        }}
                    >
                        {introVideo.file || introVideo.preview ? (
                            <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                                {formData.courseType === 'Video Course' ? (
                                    <video
                                        src={introVideo.preview}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        controls
                                    />
                                ) : (
                                    <div className="d-flex flex-column align-items-center justify-content-center h-100">
                                        <i className="bi bi-music-note-beamed" style={{ fontSize: '48px', color: '#6366F1' }}></i>
                                        <p className="mt-2 mb-0">{introVideo.file ? introVideo.file.name : 'Audio File'}</p>
                                    </div>
                                )}
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (introVideo.preview && !introVideo.preview.includes('http')) {
                                            URL.revokeObjectURL(introVideo.preview);
                                        }
                                        setIntroVideo(initialVideoState);
                                    }}
                                    className="position-absolute"
                                    style={{
                                        top: '8px',
                                        right: '8px',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '4px 8px',
                                        fontSize: '12px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Remove
                                </button>
                            </div>
                        ) : (
                            <div className="d-flex flex-column align-items-center justify-content-center text-center">
                                <span style={{ fontSize: '32px', color: '#A0AEC0' }}>+</span>
                                <p style={{ fontSize: '10px', color: '#718096', margin: '0' }}>
                                    {!formData.courseType ?
                                        'Select Course Type first to upload Introduction Media' :
                                        formData.courseType === 'Audio' ? 'Please Upload Audio in MP3/WAV format' :
                                            'Please Upload Video in MP4 format'}
                                </p>
                            </div>
                        )}
                    </div>
                </Form.Group>
            </div>
        );
    };

    const renderQuillEditorSection = () => {
        if (formData.courseType !== 'Text-Based Course') {
            return null;
        }

        return (
            <div className="row mb-4">
                <div className="col-12">
                    <Form.Group>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <Form.Label style={{ color: '#4A5568', fontWeight: '500' }}>
                                Introduction Text
                            </Form.Label>
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => setShowPreview(true)}
                                style={{ fontSize: '12px' }}
                            >
                                Preview
                            </Button>
                        </div>
                        {/* <ReactQuill
                            value={htmlContent}
                            onChange={setHtmlContent}
                            modules={quillModules}
                            formats={quillFormats}
                            style={{
                                height: '200px',
                                marginBottom: '50px'
                            }}
                            placeholder="Enter introduction content here..."
                        /> */}
                        <SunEditor
                            setContents={htmlContent}
                            onChange={setHtmlContent}
                            setOptions={sunEditorOptions}
                            style={{
                                marginBottom: '20px'
                            }}
                        />
                    </Form.Group>
                </div>
            </div>
        );
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            centered
            className="create-course-modal"
        >
            <Modal.Header closeButton className="border-bottom-1 pb-2">
                <Modal.Title>Create Course</Modal.Title>

            </Modal.Header>

            <Modal.Body className="px-4 py-3" style={{ maxHeight: 'calc(90vh - 170px)', overflowY: 'auto' }}>
                <div className="d-flex justify-content-end align-items-center">
                    <span className="text-dark me-2 mt-4">Last Updated Date -</span>
                    <span className="text-dark mt-4">NA</span>
                </div>
                <Form onSubmit={handleSubmit}>
                    {/* Basics Section */}
                    <div className="mt-4 mb-6 ">
                        <h6 className="text-primary mb-4" style={{ fontSize: '16px', color: '#6366F1' }}>Basics</h6>

                        <div className="row">
                            {/* Left Column */}
                            <div className="col-md-6 pe-md-2">
                                {/* Course Title */}
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Course Title <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="title"
                                        placeholder="Enter Course Title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    />
                                    {fieldErrors.title && (
                                        <div className="text-danger mt-1" style={{ fontSize: '12px' }}>
                                            {fieldErrors.title}
                                        </div>
                                    )}
                                </Form.Group>

                                {/* Course Type and Status */}
                                <div className="row">
                                    <div className="col-6 pe-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                Course Type <span className="text-danger">*</span>
                                            </Form.Label>
                                            <CustomDropdown
                                                name="courseType"
                                                value={formData.courseType}
                                                onChange={(e) => {
                                                    handleInputChange(e);
                                                    if (introVideo.file || htmlContent) {
                                                        // If user changes course type after uploading a file or entering content
                                                        toast.info('You changed the course type. Please update the introduction content accordingly.', {
                                                            position: "top-right",
                                                            autoClose: 5000,
                                                            hideProgressBar: false,
                                                            closeOnClick: true,
                                                            pauseOnHover: true,
                                                            draggable: true,
                                                            toastId: 'course-type-changed'
                                                        });
                                                    }
                                                }}
                                                placeholder="Select course type"
                                                options={[
                                                    {
                                                        value: "Video Course",
                                                        label: "Video Course",
                                                        description: "(Series of video lectures)"
                                                    },
                                                    {
                                                        value: "Audio",
                                                        label: "Audio",
                                                        description: "(Series of audio lectures)"
                                                    },
                                                    {
                                                        value: "Text-Based Course",
                                                        label: "Text-Based Course",
                                                        description: "(PDFs)"
                                                    }
                                                ]}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6 ps-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                Status <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="status"
                                                value={formData.status}
                                                onChange={handleInputChange}
                                                style={{
                                                    height: '44px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF'
                                                }}
                                            >
                                                <option value="" hidden>Select status</option>
                                                <option value="New">New</option>
                                                <option value="Active">Active</option>
                                                <option value="Archived">Archived</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                </div>

                                {/* Row for Thumbnail and Introduction Media */}
                                <div className="row mb-3">
                                    {/* Course Thumbnail - Left Column */}
                                    <div className="col-md-6 pe-md-2">
                                        <Form.Group>
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                Course Thumbnail
                                            </Form.Label>
                                            <input
                                                type="file"
                                                id="thumbnailFile"
                                                onChange={handleThumbnailChange}
                                                style={{ display: 'none' }}
                                                accept="image/png,image/jpeg,image/jpg"
                                            />
                                            <div
                                                className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                style={{
                                                    height: '150px',
                                                    backgroundColor: '#FFFFFF',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={triggerFileInput}
                                            >
                                                {renderThumbnailPreview()}
                                            </div>
                                        </Form.Group>
                                    </div>

                                    {/* Introduction Media Section */}
                                    {renderIntroductionMediaSection()}
                                </div>
                            </div>


                            {/* Right Column - Course Description */}
                            <div className="col-md-6 ps-md-2">
                                {/* Course Description */}
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Course Description <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            as="textarea"
                                            name="description"
                                            placeholder="Enter Course Description"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            style={{
                                                height: '137px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                resize: 'none',
                                                paddingBottom: '25px'
                                            }}
                                        />
                                        {fieldErrors.description && (
                                            <div className="text-danger mt-1" style={{ fontSize: '12px' }}>
                                                {fieldErrors.description}
                                            </div>
                                        )}
                                        <div
                                            className="position-absolute"
                                            style={{
                                                bottom: '8px',
                                                right: '20px',
                                                fontSize: '12px',
                                                color: '#6B7280'
                                            }}
                                        >
                                            {charCount}/300
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>
                        {renderQuillEditorSection()}

                        {/*Addditional Details */}
                        <div className="mb-4 mt-5">
                            <h6 className="mb-3" style={{ fontSize: '16px', color: '#6366F1' }}>Additional Details</h6>
                            <div className="row mb-3">
                                {/* Related Parikramas */}
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Related Parikramas
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type="text"
                                                name="relatedJourney"
                                                placeholder="Search Related Parikramas"
                                                value={searchJourney}
                                                onChange={(item) => {
                                                    setSearchJourney(item.target.value);
                                                }}
                                                style={{
                                                    height: '44px',
                                                    paddingRight: '35px',
                                                    paddingLeft: '12px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF'
                                                }}
                                            />
                                            <img
                                                src={Search}
                                                alt="search"
                                                className="position-absolute"
                                                style={{
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: '16px',
                                                    height: '16px',
                                                    zIndex: 2
                                                }}
                                            />
                                            {/* Journey Search Results Dropdown */}
                                            {searchJourney.length > 0 && journeyResults.filter((journey) =>
                                                journey.trip_name.toLowerCase().includes(searchJourney.toLowerCase())).length > 0 && (
                                                    <div
                                                        className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                        style={{
                                                            zIndex: 1000,
                                                            maxHeight: '200px',
                                                            overflowY: 'auto'
                                                        }}
                                                    >
                                                        {journeyResults.filter((journey) =>
                                                            journey.trip_name.toLowerCase().includes(searchJourney.toLowerCase())).map(journey => {
                                                                const isSelected = selectedJourneys.some(j => j.journey_id === journey.journey_id);
                                                                if (!isSelected) {
                                                                    return (
                                                                        <div
                                                                            key={journey.journey_id}
                                                                            className="p-2 cursor-pointer hover:bg-gray-100"
                                                                            onClick={() => handleJourneySelect(journey)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {journey.trip_name}
                                                                        </div>
                                                                    );
                                                                }
                                                                return null;
                                                            })}
                                                    </div>
                                                )}
                                        </div>
                                    </Form.Group>
                                </div>

                                {/* Selected Parikramas */}
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Selected Parikramas
                                        </Form.Label>
                                        <div className="position-relative">
                                            <div
                                                style={{
                                                    minHeight: '100px',
                                                    maxHeight: '100px',
                                                    height: 'auto',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '0.375rem',
                                                    padding: '12px',
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <div className="d-flex flex-wrap gap-2">
                                                    {selectedJourneys.map((journey) => (
                                                        <span
                                                            key={journey.journey_id}
                                                            className="d-inline-flex align-items-center"
                                                            style={{
                                                                backgroundColor: '#6366F1',
                                                                color: 'white',
                                                                padding: '6px 12px',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                marginBottom: '4px'
                                                            }}
                                                        >
                                                            {journey.trip_name}
                                                            <button
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleJourneyRemove(journey.journey_id);
                                                                }}
                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                style={{
                                                                    padding: '0',
                                                                    lineHeight: 1,
                                                                    fontSize: '18px',
                                                                    fontWeight: 'bold',
                                                                    opacity: 0.8,
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="row mb-3">
                                {/* Related Deities */}
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Related Deities
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type="text"
                                                name="searchDeity"
                                                placeholder="Search Related Deities"
                                                value={searchDeity}
                                                onChange={(e) => setSearchDeity(e.target.value)}
                                                style={{
                                                    height: '44px',
                                                    paddingRight: '35px',
                                                    paddingLeft: '12px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF'
                                                }}
                                            />
                                            <img
                                                src={Search}
                                                alt="search"
                                                className="position-absolute"
                                                style={{
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: '16px',
                                                    height: '16px',
                                                    zIndex: 2
                                                }}
                                            />
                                            {/* Deity Search Results Dropdown */}
                                            {searchDeity.length > 0 && deityResults.filter((deity) =>
                                                deity.deity_name.toLowerCase().includes(searchDeity.toLowerCase())).length > 0 && (
                                                    <div
                                                        className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                        style={{
                                                            zIndex: 1000,
                                                            maxHeight: '200px',
                                                            overflowY: 'auto'
                                                        }}
                                                    >
                                                        {deityResults.filter((deity) =>
                                                            deity.deity_name.toLowerCase().includes(searchDeity.toLowerCase())).map(deity => {
                                                                const isSelected = selectedDeities.some(d => d.deity_id === deity.deity_id);
                                                                if (!isSelected) {
                                                                    return (
                                                                        <div
                                                                            key={deity.deity_id}
                                                                            className="p-2 cursor-pointer hover:bg-gray-100"
                                                                            onClick={() => handleDeitySelect(deity)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {deity.deity_name}
                                                                        </div>
                                                                    );
                                                                }
                                                                return null;
                                                            })}
                                                    </div>
                                                )}
                                        </div>
                                    </Form.Group>
                                </div>

                                {/* Selected Deities */}
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Selected Deities
                                        </Form.Label>
                                        <div className="position-relative">
                                            <div
                                                style={{
                                                    minHeight: '100px',
                                                    maxHeight: '100px',
                                                    height: 'auto',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '0.375rem',
                                                    padding: '12px',
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <div className="d-flex flex-wrap gap-2">
                                                    {selectedDeities.map((deity) => (
                                                        <span
                                                            key={deity.deity_id}
                                                            className="d-inline-flex align-items-center"
                                                            style={{
                                                                backgroundColor: '#6366F1',
                                                                color: 'white',
                                                                padding: '6px 12px',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                marginBottom: '4px'
                                                            }}
                                                        >
                                                            {deity.deity_name}
                                                            <button
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleDeityRemove(deity.deity_id);
                                                                }}
                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                style={{
                                                                    padding: '0',
                                                                    lineHeight: 1,
                                                                    fontSize: '18px',
                                                                    fontWeight: 'bold',
                                                                    opacity: 0.8,
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>

                            <div className="row mb-3">
                                {/* Related Teerthas */}
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Related Teerthas
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type="text"
                                                name="searchWaypoint"
                                                placeholder="Search Related Teerthas"
                                                value={searchWaypoint}
                                                onChange={(e) => {
                                                    setSearchWaypoint(e.target.value);
                                                    if (e.target.value.length > 1) {
                                                        searchWaypoints(e.target.value);
                                                    }
                                                }}
                                                style={{
                                                    height: '44px',
                                                    paddingRight: '35px',
                                                    paddingLeft: '12px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF'
                                                }}
                                            />
                                            <img
                                                src={Search}
                                                alt="search"
                                                className="position-absolute"
                                                style={{
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: '16px',
                                                    height: '16px',
                                                    zIndex: 2
                                                }}
                                            />
                                            {/* Waypoint Search Results Dropdown */}
                                            {searchWaypoint.length > 1 && waypointResults.length > 0 && (
                                                <div
                                                    className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                    style={{
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto'
                                                    }}
                                                >
                                                    {waypointResults.map(waypoint => {
                                                        const isSelected = selectedWaypoints.some(w => w.wpt_id === waypoint.wpt_id);
                                                        if (!isSelected) {
                                                            return (
                                                                <div
                                                                    key={waypoint.wpt_id}
                                                                    className="p-2 cursor-pointer hover:bg-gray-100"
                                                                    onClick={() => handleWaypointSelect(waypoint)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {waypoint.wpt_name}
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Group>
                                </div>

                                {/* Selected Teerthas */}
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Selected Teerthas
                                        </Form.Label>
                                        <div className="position-relative">
                                            <div
                                                style={{
                                                    minHeight: '100px',
                                                    maxHeight: '100px',
                                                    height: 'auto',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '0.375rem',
                                                    padding: '12px',
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <div className="d-flex flex-wrap gap-2">
                                                    {selectedWaypoints.map((waypoint) => (
                                                        <span
                                                            key={waypoint.wpt_id}
                                                            className="d-inline-flex align-items-center"
                                                            style={{
                                                                backgroundColor: '#6366F1',
                                                                color: 'white',
                                                                padding: '6px 12px',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                marginBottom: '4px'
                                                            }}
                                                        >
                                                            {waypoint.wpt_name}
                                                            <button
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleWaypointRemove(waypoint.wpt_id);
                                                                }}
                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                style={{
                                                                    padding: '0',
                                                                    lineHeight: 1,
                                                                    fontSize: '18px',
                                                                    fontWeight: 'bold',
                                                                    opacity: 0.8,
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Category <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleInputChange}
                                            className="category-select"
                                            style={{
                                                height: '44px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            <option value="" hidden>Select Category</option>
                                            <option value="Foundations of Sanatan Dharma">Foundations of Sanatan Dharma (Bharatiya Dharma Mool)</option>
                                            <option value="Parikrama Preparation & Practices">Parikrama Preparation & Practices (Yatra Sadhana)</option>
                                            <option value="Stotra & Mantra Learning">Dharma Quotes</option>
                                            <option value="Scriptural Studies">Scriptural Studies (Shastra Pathshaala)</option>
                                            <option value="Life Lessons from Saints & Gurus">Life Lessons from Saints & Gurus (Sadguru Smriti)</option>
                                            <option value="Festival Wisdom">Festival Wisdom (Utsav Gyaan)</option>
                                            {/* <option value="Spiritual Practices & Sadhana">Spiritual Practices & Sadhana (Adhyatma Abhyas)</option>
                                            <option value="Spiritual Lifestyle & Ethics">Spiritual Lifestyle & Ethics (Dharmik Jeevan Shailee)</option>
                                            <option value="Other/Astrology">Other/Astrology</option> */}
                                        </Form.Select>
                                        {/* Add this style block inside the Form.Group */}
                                        <style jsx>{`
                                            .category-select option {
                                                text-overflow: ellipsis;
                                                overflow: hidden;
                                                white-space: nowrap;
                                            }
                                        `}</style>
                                    </Form.Group>
                                </div>
                                {/* Add the language dropdown here */}
                                <div className="col-md-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Language <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="language"
                                            value={formData.language}
                                            onChange={handleInputChange}
                                            style={{
                                                height: '44px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        >
                                            <option value="" hidden>Select Language</option>
                                            <option value="English">English</option>
                                            <option value="Marathi">Marathi</option>
                                            <option value="Hindi">Hindi</option>
                                            <option value="Gujarati">Gujarati</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>

                                <div className="col-md-3">
                                    {/* Subscription Type */}
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Subscription Type <span className="text-danger">*</span>
                                        </Form.Label>
                                        <div className="d-flex gap-4">
                                            <Form.Check
                                                type="radio"
                                                id="free"
                                                name="subscriptionType"
                                                value="Free"
                                                label="Free"
                                                checked={formData.subscriptionType === 'Free'}
                                                onChange={handleInputChange}
                                            />
                                            <Form.Check
                                                type="radio"
                                                id="paid"
                                                name="subscriptionType"
                                                value="Paid"
                                                label="Paid"
                                                checked={formData.subscriptionType === 'Paid'}
                                                onChange={handleInputChange}
                                                disabled={true}
                                            />
                                        </div>
                                    </Form.Group>
                                </div>

                                <div className="col-md-3">
                                    {/* Certificate Enabled */}
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Issue Certification on Course Completion
                                        </Form.Label>
                                        <div className="toggle-switch-container">
                                            <label className="toggle-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={formData.certificateEnabled}
                                                    name="certificateEnabled"
                                                    onChange={handleCheckboxChange}
                                                />
                                                <span className="slider round">
                                                    <span className="on-text" style={{ opacity: formData.certificateEnabled ? 1 : 0 }}>On</span>
                                                    <span className="off-text" style={{ opacity: formData.certificateEnabled ? 0 : 1 }}>Off</span>
                                                </span>
                                            </label>
                                            <style jsx>{`
                                                .toggle-switch {
                                                    position: relative;
                                                    display: inline-block;
                                                    width: 50px;
                                                    height: 24px;
                                                }
                                                
                                                .toggle-switch input {
                                                    opacity: 0;
                                                    width: 0;
                                                    height: 0;
                                                }
                                                
                                                .slider {
                                                    position: absolute;
                                                    cursor: pointer;
                                                    top: 0;
                                                    left: 0;
                                                    right: 0;
                                                    bottom: 0;
                                                    background-color: #ccc;
                                                    transition: .3s;
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: space-between;
                                                    padding: 0 6px;
                                                }
                                                
                                                .slider:before {
                                                    position: absolute;
                                                    content: "";
                                                    height: 18px;
                                                    width: 18px;
                                                    left: 3px;
                                                    bottom: 3px;
                                                    background-color: white;
                                                    transition: .3s;
                                                    transform: ${formData.certificateEnabled ? 'translateX(26px)' : 'translateX(0)'};
                                                    z-index: 2;
                                                }
                                                
                                                input:checked + .slider {
                                                    background-color: #6366F1;
                                                }
                                                
                                                input:focus + .slider {
                                                    box-shadow: 0 0 1px #6366F1;
                                                }
                                                
                                                .slider.round {
                                                    border-radius: 24px;
                                                }
                                                
                                                .slider.round:before {
                                                    border-radius: 50%;
                                                }
                                                
                                                .on-text, .off-text {
                                                    color: white;
                                                    font-size: 10px;
                                                    position: relative;
                                                    z-index: 1;
                                                    transition: opacity 0.2s;
                                                }
                                                
                                                .on-text {
                                                    margin-right: auto;
                                                }
                                                
                                                .off-text {
                                                    margin-left: auto;
                                                    margin-right: 3px;
                                                }
                                            `}</style>
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>

                {/* Preview Modal */}
                <Modal
                    show={showPreview}
                    onHide={() => setShowPreview(false)}
                    size="lg"
                    centered
                    className="preview-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Mobile Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0, display: 'flex', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
                        <div style={{
                            width: '280px',
                            height: '580px',
                            backgroundColor: 'white',
                            margin: '20px',
                            borderRadius: '25px',
                            padding: '20px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                            border: '8px solid #2c3e50',
                            position: 'relative',
                            overflow: 'hidden',
                            boxSizing: 'border-box'
                        }}>
                            {/* Header */}
                            <div style={{
                                textAlign: 'center',
                                padding: '5px 0',
                                borderBottom: '1px solid #e0e0e0',
                                marginBottom: '20px'
                            }}>
                                <h4 style={{ color: '#333', margin: 0 }}>Introduction</h4>
                            </div>

                            {/* Title */}
                            <div style={{
                                textAlign: 'center',
                                marginBottom: '20px'
                            }}>
                                <h5 style={{ color: '#333', margin: 0, fontWeight: '600', wordWrap: 'break-word', maxWidth: '100%' }}>
                                    {formData.title || 'Course Title'}
                                </h5>
                            </div>

                            {/* Content */}
                            <div style={{
                                height: '400px',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                boxSizing: 'border-box',
                                padding: '0 10px',
                                fontSize: '14px',
                                lineHeight: '1.6',
                                color: '#333',
                                msOverflowStyle: 'none',   // Hides scrollbar in IE/Edge
                                scrollbarWidth: 'none',    // Hides scrollbar in Firefox
                                '::-webkit-scrollbar': {   // Hides scrollbar in Chrome/Safari
                                    display: 'none'
                                }
                            }}>
                                <div
                                    style={{
                                        maxWidth: '100%',
                                        wordWrap: 'break-word',
                                        wordBreak: 'break-word',
                                        overflow: 'hidden'
                                    }}
                                    className="preview-content"
                                >
                                    <div
                                        dangerouslySetInnerHTML={{ __html: processHtmlForPreview(htmlContent) }}
                                        style={{
                                            maxWidth: '100%',
                                            wordWrap: 'break-word',
                                            wordBreak: 'break-word',
                                            overflow: 'hidden'
                                        }}
                                        className="preview-content"
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </Modal.Body>

            <Modal.Footer className="border-top-1">
                <Button
                    variant="primary"
                    className="px-4 py-2 ms-auto"
                    style={{ backgroundColor: '#6366F1' }}
                    onClick={handleSubmit}
                    disabled={isSubmitting || isSubmitted}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateCourse;